/* dusa: fills the "Estimated delivery" line rendered by snippets/dusa-shipping-line.liquid.
   Range = 1 business day of processing, then UPS Ground transit from Pennsylvania
   for the shopper's time zone. Weekends and the theme's "Carrier holidays" setting
   (the element's data-holidays) are skipped. Dates only: shipping cost stays at checkout.
   A MutationObserver picks up lines the cart drawer renders after an add to cart. */
(function () {
  'use strict';

  // UPS Ground transit from Pennsylvania, in business days, by the shopper's time zone.
  // Alaska and Hawaii get no estimate; anything else (or unknown) gets the national band.
  function transitBand() {
    var zone = '';
    try {
      zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {}
    if (/^(America\/(Anchorage|Juneau|Sitka|Nome|Adak|Metlakatla|Yakutat)|Pacific\/Honolulu)/.test(zone)) return null;
    if (/^America\/(New_York|Detroit|Indiana|Kentucky|Toronto|Montreal)/.test(zone)) return [1, 3];
    if (/^America\/(Chicago|Menominee|North_Dakota|Winnipeg)/.test(zone)) return [2, 4];
    if (/^America\/(Denver|Boise|Phoenix|Edmonton)/.test(zone)) return [3, 5];
    if (/^America\/(Los_Angeles|Vancouver)/.test(zone)) return [4, 5];
    return [1, 5];
  }

  // Dates are UTC midnights so the shopper's own time zone can't shift them.
  function warehouseToday(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(now)
      .forEach(function (p) {
        parts[p.type] = p.value;
      });
    return new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
  }

  function estimate(holidayList, band, now) {
    var holidays = {};
    (holidayList || '').split(',').forEach(function (d) {
      d = d.trim();
      if (d) holidays[d] = true;
    });
    function addBusinessDays(date, n) {
      var d = new Date(date.getTime());
      while (n > 0) {
        d.setUTCDate(d.getUTCDate() + 1);
        var day = d.getUTCDay();
        if (day !== 0 && day !== 6 && !holidays[d.toISOString().slice(0, 10)]) n -= 1;
      }
      return d;
    }
    var today = warehouseToday(now || new Date());
    var first = addBusinessDays(addBusinessDays(today, 1), band[0]);
    var last = addBusinessDays(addBusinessDays(today, 1), band[1]);
    var fmt = { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };
    return first.toLocaleDateString('en-US', fmt) + ' – ' + last.toLocaleDateString('en-US', fmt);
  }

  function syncPdp(el) {
    var add = document.querySelector('product-info [name="add"]');
    el.hidden = !!(add && add.disabled);
    if (add && !add.dataset.dusaEtaWatched) {
      add.dataset.dusaEtaWatched = 'true';
      new MutationObserver(function () {
        document.querySelectorAll('[data-dusa-eta-pdp][data-dusa-eta-done]').forEach(syncPdp);
      }).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function fill() {
    var pending = document.querySelectorAll('[data-dusa-eta]:not([data-dusa-eta-done])');
    if (!pending.length) return;
    var band = transitBand();
    pending.forEach(function (el) {
      el.setAttribute('data-dusa-eta-done', '');
      if (!band) return;
      var range = el.querySelector('[data-dusa-eta-range]');
      if (range) range.textContent = estimate(el.getAttribute('data-holidays'), band);
      el.hidden = false;
      if (el.hasAttribute('data-dusa-eta-pdp')) syncPdp(el);
    });
  }

  window.dusaDeliveryEstimate = estimate;

  function init() {
    fill();
    new MutationObserver(fill).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
